export enum ShopPostStatus {
  AwaitsCustomer = -2,
  AwaitsDesigner = -1,
  Planned = 0,
  ToBePosted = 1,
  Posted = 2,
  Error = 3
}
